import { ReactNode } from 'react'

interface ReversedWrapperProps {
  childX: ReactNode
  childY: ReactNode
  isReversed: boolean
  delimiter?: ReactNode
}

export const ReversedWrapper = ({ childX, childY, isReversed, delimiter = null }: ReversedWrapperProps) => {
  return (
    <>
      {isReversed ? (
        <>
          {childY}
          {delimiter}
          {childX}
        </>
      ) : (
        <>
          {childX}
          {delimiter}
          {childY}
        </>
      )}
    </>
  )
}
